import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { HomeComponent } from './home/home.component';
import { SelectAvatarComponent } from './user/select-avatar/select-avatar.component';
import { SelectAvatarGuard } from './user/select-avatar/select-avatar.guard';
import { UserSettingsComponent } from './user/user-setting/user-settings.component';
import { UserSetupComponent } from './user/user-setup/user-setup.component';
import { UserInfoResolver } from './user/user.resolver';
import { UserComponent } from './user/user/user.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'forum',
    loadChildren: () => import('./forum/forum.module').then((m) => m.ForumModule)
  },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'user/recover', component: ResetPasswordComponent },
  {
    path: 'user/settings',
    component: UserSettingsComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    resolve: { userInfo: UserInfoResolver }
  },
  {
    path: 'user/setup',
    component: UserSetupComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    resolve: { userInfo: UserInfoResolver }
  },
  {
    path: 'profile/:username',
    component: UserComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    resolve: { userInfo: UserInfoResolver }
  },
  {
    path: 'user/select-avatar',
    component: SelectAvatarComponent,
    resolve: { userInfo: UserInfoResolver },
    canActivate: [AuthGuard, SelectAvatarGuard]
  },
  { path: 'verify', component: VerifyEmailComponent },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
